/**
 * Custom scrollTo implementation with crosss browser easing support.
 * Supports both window and element scrolling.
 *
 * Safari does not support smooth scrolling using the built in browser scrollTo API
 * so we need to roll our own that will work on all browsers. The use of requestAnimationFrame
 * should make this performant.
 *
 * @param element: [required] The element you want the scroll to apply to. Use 'window' for window
 * @param to: [required] the offset (in px) to scroll to. Note that it will add this to the current position
 * @param duration: [required] the duration (in ms) for the scrolling animation
 * @param direction: [optional] (default: 'horizontal') The direction for the scrolling animation (horizontal | vertical)
 * @param easingFcn: [optional] (default: easeInOutCubic) The easing function to use for the animation.
 */
function scrollToAnimated(element, to, duration, direction) {
  var easingFcn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : easeInOutCubic;

  if (!element || to === undefined || !duration) {
    return false;
  }

  var end = +new Date() + duration;
  var from = element === 'window' ? window.pageXOffset : element.scrollLeft;

  if (direction === 'vertical') {
    from = element === 'window' ? window.pageYOffset : element.scrollTop;
  }

  var step = function step() {
    var current = +new Date();
    var remaining = end - current;

    if (remaining >= 0) {
      var ease = easingFcn(1 - remaining / duration);

      if (!direction || direction === 'horizontal') {
        element === 'window' ? window.scrollTo(from + ease * (to - from), window.pageYOffset) : element.scrollLeft = from + ease * (to - from);
      } else if (direction === 'vertical') {
        element === 'window' ? window.scrollTo(window.pageXOffset, from + ease * (to - from)) : element.scrollTop = from + ease * (to - from);
      }

      window.requestAnimationFrame(step);
    }
  };

  step();
}

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; // eslint-disable-line
}

export default scrollToAnimated;